<template>
  <div>
    <h1>Page non trouvée</h1>
  </div>
</template>

<script>
export default {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
